<template>
  <v-container fluid class="ml-n6">
    <v-row>
      <v-col v-if="isLoading">
        <ProgressLinearLoaderVue :isLoading="isLoading" />
      </v-col>
      <v-col v-else>
        <BannerAlertVue
          v-if="!aginovaMonitorsList.length && !isEditingMode"
          :message="bannerMessage"
        />
        <router-view v-else />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import ProgressLinearLoaderVue from '@/Core.UI.Domain/Components/ProgressLinearLoader.vue';
import BannerAlertVue from '@/Core.UI.Domain/Components/BannerAlert.vue';
import type { IAginovaMonitor } from '@/Core.Service.Domain/Monitors/Aginova/types';

const route = useRoute();
const store = useStore();

const aginovaMonitorsList = computed<IAginovaMonitor[]>(
  () =>
    store.getters[
      'MonitorsStore/AginovaMonitorsStore/selectedSiteWithAginovaMonitors'
    ]
);

const isLoading = computed<boolean>(
  () =>
    store.getters[
      'MonitorsStore/AginovaMonitorsStore/selectedSiteWithAginovaMonitorsIsLoading'
    ]
);

const bannerMessage = computed(() => `No devices configured for this site`);

const isEditingMode = computed(() => route.name === 'EditAginovaMonitor');
</script>

<script lang="ts">
export default {
  name: 'AginovaMonitorsPortfolio',
};
</script>
